import * as React from 'react';
import CarMainReport from './ReportsComposites/CarMainReport';
import ReportManual from './ReportsComposites/ReportManual';
import {withTranslation} from 'react-i18next';
import i18next from 'i18next';
import {ReportType} from '../../Models/EnumTypes/ReportEnumTypes';
import * as VehiclesModule from "Modules/VehiclesModule";
import * as FleetModule from "Modules/FleetModule";
import {connect} from "react-redux";

type P = {
    t?: i18next.TFunction;
    getCars: Function;
    getUsersFleet: Function;
};

class CarReport extends React.Component<P> {

    public async componentDidMount() {
        await this.props.getCars();
        await this.props.getUsersFleet();
    }

    public render() {
        const {t} = this.props;
        return (
            <div className="main__content">
                <h3 className="main__title">{t('carMainReport')}</h3>
                <div className="flex">
                    <div className="main__inner-left">
                        <ReportManual reportType={ReportType.MAIN_CAR_REPORT}/>
                    </div>
                    <div className="main__inner-right main__inner-right--flex-4">
                        <CarMainReport/>
                    </div>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch: any): P {
    return {
        getCars: () => dispatch(VehiclesModule.Actions.getCars()),
        getUsersFleet: () => dispatch(FleetModule.Actions.getUsersFleet())
    };
}

export default withTranslation('reports')(connect(
    null,
    mapDispatchToProps
)(CarReport) as React.ComponentClass<any>);



// WEBPACK FOOTER //
// ./src/components/Raports/CarReport.tsx